import {useCallback, useState} from 'react'

type UseDrawerReturn = {
  close: VoidFunction
  open: VoidFunction
  opened: boolean
}

/**
 * Возвращает состояние `Drawer` и коллбеки для его открытия/закрытия
 * @param defaultOpened Состояние, открыт ли `Drawer` по умолчанию. По умолчанию `false`
 * @returns состояние `Drawer` и коллбеки для его открытия/закрытия
 */
export const useDrawer = (defaultOpened = false): UseDrawerReturn => {
  const [opened, setOpened] = useState(defaultOpened)

  const close = useCallback(() => {
    setOpened(false)
  }, [])

  const open = useCallback(() => {
    setOpened(true)
  }, [])

  return {
    close,
    open,
    opened,
  }
}
